import React, { useState, useRef, useEffect } from 'react';
import style from './FooterJobApplicationForm.module.css';
import axios from 'axios';
import ThankYou from '../ThankYou/ThankYou';
import { API_URL } from '../../const';
import { useCheckActiveVacancies } from '../../hooks/useCheckActiveVacancies';



const FooterJobApplicationForm = () => {

    const activeVacancies = useCheckActiveVacancies();

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const [selectCountry, setSelectCountry] = useState("Select your country");
    const [countryError, setCountryError] = useState("");

    const [selectPosition, setSelectPosition] = useState("Select a job");
    const [positionError, setPositionError] = useState("");

    const [message, setMessage] = useState("");
    const [messageError, setMessageError] = useState("");

    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState("");

    const [form, setForm] = useState(true);
    const [thankYou, setThankYou] = useState(false);

    const [disableButton, setDisableButton] = useState(false);

    const handlerName = (e) => {
        setName(e.target.value);
        if (name) setNameError(false)
    };

    const handlerEmail = (e) => {
        setEmail(e.target.value.toLowerCase());
        const re = /^(([^а-яА-Я<>()[\]\.,;:\s@\"]+(\.[^а-яА-Я<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@([a-zA-Z0-9!#$%&'*+\-\/=?^`{|}~]+(\.[a-zA-Z0-9!#$%&'*+\-\/=?^`{|}~]+)*\.[a-zA-Z]{2,})$/; if (!re.test(String(e.target.value).toLowerCase())) {
            setEmailError("*Please enter valid e-mail address.");
        } else {
            setEmailError('');
        }
    }

    const handlerMessage = (e) => {
        setMessage(e.target.value);
        if (message) setMessageError(false)
    }

    useEffect(() => {
        if (selectCountry !== 'Select your country') setCountryError(false)
        if (selectPosition !== "Select a job") setPositionError(false)
    }, [selectCountry, selectPosition]);

    const handlerFile = (e) => {
        setFile(e.target.files[0]);
        if (e.target.files[0].size > 5242880) {
            setFileError("*The attached file must be no larger than 5 MB.")
        } else {
            setFileError('')
        }
    };

    const select1 = useRef();
    const select2 = useRef();

    const selectToggle1 = () => {
        select1.current.classList.toggle(style.isActive);
        select2.current.classList.remove(style.isActive);
    }
    const selectToggle2 = () => {
        select2.current.classList.toggle(style.isActive);
        select1.current.classList.remove(style.isActive);
    }

    const selectChoose1 = (e) => {
        const text = e.target.innerHTML;
        setSelectCountry(text);
        select1.current.classList.remove(style.isActive);
    }

    const handlerPosition = (e) => {
        setSelectPosition(e.target.value);
        if (selectPosition) setPositionError(false)
    };

    const selectChoose2 = (e) => {
        const text = e.target.innerHTML;
        setSelectPosition(text);
        select1.current.classList.remove(style.isActive);
        select2.current.classList.remove(style.isActive);
    }

    useEffect(() => {
        document.addEventListener('click', handleClickOutsideSelect, true)
        return () => {
            document.removeEventListener("click", handleClickOutsideSelect);
        };
    }, [select1, select2]);

    const handleClickOutsideSelect = (e) => {
        if (select1.current && !select1.current.contains(e.target)) {
            select1.current.classList.remove(style.isActive);
        }
        if (select2.current && !select2.current.contains(e.target)) {
            select2.current.classList.remove(style.isActive);
        }
    }

    const thankYouMobile = () => {
        const windowInnerWidth = window.innerWidth;
        if (windowInnerWidth < 768) {
            setForm(false)
            let container = document.querySelector(`.${style.container}`);
            container.style.height = '750px';
            container.style.paddingTop = '160px';
        }
    }

    useEffect(() => {
        setDisableButton(false);
    }, [name, email, selectCountry, selectPosition, message, file]);

    const submitForm = (name, email, selectCountry, selectPosition, message, file) => {

        const formData = new FormData();
        formData.append("file", file);

        if (name === '') {
            setNameError('*Please enter your full name.');
        }
        if (email === '') {
            setEmailError('*Please enter your e-mail address.');
        }

        if (message === '') {
            setMessageError('*Please enter your message.');
        }
        if (selectCountry === 'Select your country') {
            setCountryError('*Please select your country.');
        }

        if (selectPosition === "Select a job" || selectPosition === '') {
            if (selectPosition === "Select a job") {
                setPositionError('*Please select your position.')
            } else {
                setPositionError('*Please enter your position.')
            }
        }

        if (nameError === false
            && emailError === ''
            && messageError === false
            && countryError === false
            && positionError === false
            && fileError === ''
        ) {
            thankYouMobile()
            setDisableButton(true);

            if (file) {

                axios.post(`${API_URL}/api/upload-file`, formData)
                    .then((res) => {
                        axios.post(`${API_URL}/api/send-vacancy-form`, {
                            name,
                            email,
                            country: selectCountry,
                            position: selectPosition,
                            message,
                            attachmentUrl: res.data.url,
                            attachmentName: res.data.name
                        })
                            .then(() => {
                                setThankYou(true)
                                setDisableButton(false);
                            })
                            .catch((error) => {
                                console.log('send-form error', error)
                            })
                    })
                    .catch((error) => {
                        console.log('upload-file error', error)
                    })

            } else {
                axios.post(`${API_URL}/api/send-vacancy-form`, {
                    name,
                    email,
                    country: selectCountry,
                    position: selectPosition,
                    message
                })
                    .then(() => {
                        setThankYou(true)
                        setDisableButton(false);
                    })
                    .catch((error) => {
                        console.log('send-form error', error)
                    })
            }
        }
    }


    let country_list = [
        "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla",
        "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia",
        "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
        "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia",
        "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands",
        "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
        "Cameroon", "Canada", "Cayman Islands", "Central African Republic",
        "Chad", "Chile", "China", "Colombia", "Comoros",
        "Cook Islands", "Costa Rica", "Côte d'Ivoire",
        "Croatia", "Cuba", "Cyprus", "Czechia", "Denmark", "Djibouti",
        "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
        "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
        "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France",
        "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia",
        "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam",
        "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti",
        "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia",
        "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica",
        "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kosovo",
        "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia",
        "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau",
        "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
        "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia",
        "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco",
        "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
        "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria",
        "North Korea", "North Macedonia", "Norway", "Oman", "Pakistan", "Palau",
        "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru",
        "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion",
        "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
        "Saint Vincent and the Grenadines", "Samoa", "San Marino",
        "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone",
        "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia",
        "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka",
        "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", "Taiwan",
        "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga",
        "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan",
        "Turks and Caicos", "Tuvalu", "Uganda", "Ukraine",
        "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
        "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands (US)",
        "Yemen", "Zambia", "Zimbabwe"
    ];

    return (
        <div className={style.wrapper} id='contactForm__wrapper'>
            <div className={style.container} >

                {form && (
                    <>
                        <div className={style.information}>
                            <h2 className={style.information__title} id="contact">Let’s build something<br />great together!</h2>
                            <p className={style.information__text} >If you are ready to be part of the team, then fill out the form below and start your journey at Nitrix. Our HR will contact you for further interviews.</p>
                        </div>

                        <div className={style.form} >

                            <div className={style.inputWrapper}>
                                <label className={style.visuallyHidden} htmlFor="name">Enter your full name</label>
                                <input className={style.form__name}
                                    type="text"
                                    name="name"
                                    id="name"
                                    placeholder="Enter your full name"
                                    onChange={(e) => handlerName(e)}
                                    autoComplete="off"
                                />
                                {nameError && <p className={style.inputError}>{nameError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <div className={style.form__country}>
                                    <div className={style.select} ref={select1}>
                                        <div className={style.select__header} onClick={selectToggle1}>
                                            <span className={style.select__current}>{selectCountry}</span>
                                            <div className={style.select__icon}></div>
                                        </div>

                                        <div className={style.select__body}>
                                            {country_list.map((country, index) => (
                                                <div className={`${style.select__item}`} onClick={e => selectChoose1(e)} key={index}>{country}</div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                {countryError && <p className={style.inputError}>{countryError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <label className={style.visuallyHidden} htmlFor="email">Enter your E-mail address</label>
                                <input className={style.form__email}
                                    type="text"
                                    value={email}
                                    placeholder="Enter your E-mail address"
                                    onChange={(e) => handlerEmail(e)}
                                    autoComplete="off"
                                />
                                {emailError && <p className={style.inputError}>{emailError}</p>}
                            </div>

                            {
                                (activeVacancies !== null && activeVacancies !== undefined && activeVacancies.length > 0)

                                    ? (
                                        <div className={style.inputWrapper}>
                                            <div className={style.form__position}>
                                                <div className={style.select} ref={select2}>
                                                    <div className={style.select__header} onClick={selectToggle2}>
                                                        <span className={style.select__current}>{selectPosition}</span>
                                                        <div className={style.select__icon}></div>
                                                    </div>

                                                    <div className={style.select__body}>
                                                        {activeVacancies.map((vacancy, index) => (
                                                            <div className={`${style.select__item}`} onClick={e => selectChoose2(e)} key={index}>{vacancy?.name}</div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            {countryError && <p className={style.inputError}>{positionError}</p>}
                                        </div>
                                    )

                                    : (<div className={style.inputWrapper}>
                                        <label className={style.visuallyHidden} htmlFor="position">Enter the vacancy you are interested in</label>
                                        <input className={style.form__name}
                                            type="text"
                                            name="position"
                                            id="position"
                                            placeholder="Enter the vacancy you are interested in..."
                                            onChange={(e) => handlerPosition(e)}
                                            autoComplete="off"
                                        />
                                        {positionError && <p className={style.inputError}>{positionError}</p>}
                                    </div>)
                            }

                            <div className={style.inputWrapper} >
                                <label className={style.visuallyHidden} htmlFor="message">Write your message</label>
                                <textarea className={style.form__message}
                                    rows="5"
                                    type="text"
                                    name="message"
                                    id="message"
                                    placeholder="Write your message"
                                    onChange={(e) => handlerMessage(e)}
                                />
                                {messageError && <p className={style.inputError__message}>{messageError}</p>}
                            </div>

                            <div className={style.inputWrapper}>
                                <label className={style.form__file} htmlFor="file-input">
                                    <br />Drop your CV here {file && <small style={{ color: 'white', fontSize: '16px', width: '100px', height: 'auto', overflow: 'hidden' }}>{file.name}</small>}
                                </label>

                                <input className={style.visuallyHidden}
                                    id="file-input"
                                    type="file"
                                    name="file"
                                    accept=".pdf, .doc, .docx, .PDF, .DOC, .DOCX,"
                                    multiple
                                    onChange={(e) => handlerFile(e)} />
                                {fileError && <p className={style.inputError__file}>{fileError}</p>}
                            </div>

                            <button
                                className={style.form__button}
                                onClick={() => submitForm(name, email, selectCountry, selectPosition, message, file)}
                                disabled={disableButton}
                            >
                                Apply <br /> for a job
                            </button>

                        </div>
                    </>
                )}

                {thankYou && <ThankYou />}

            </div>
        </div>
    )
}

export default FooterJobApplicationForm;